import {defineNuxtPlugin} from '#app'

// Autoplay policy: WebAudio мовчить, доки у вкладці не сталося жодної взаємодії. Ловимо
// найперший жест (клік по логіну, скрол-тап, будь-яка клавіша) і одразу піднімаємо
// AudioContext — далі сигнали нових нотаток у треді лунають без додаткових кліків,
// навіть якщо черговий просто дивиться на мапу годинами.
//
// { once: true, capture: true } — знімаємо слухачі відразу після першого жесту; capture,
// щоб нас не з'їв stopPropagation з дочірніх компонентів (мапа, діалоги).
export default defineNuxtPlugin(() => {
  const {unlockNoteSound, muted} = useUavNoteSound()
  const events = ['pointerdown', 'keydown', 'touchstart'] as const

  const unlock = () => {
    // Звук вимкнено (за замовчуванням) — не піднімаємо AudioContext дарма; коли черговий
    // увімкне перемикач, той клік сам стане потрібним жестом.
    if (!muted.value) unlockNoteSound()
    events.forEach(e => window.removeEventListener(e, unlock, true))
  }

  events.forEach(e => window.addEventListener(e, unlock, {once: true, capture: true}))
})
